import { Customer } from 'types/CustomerTypes';
import { CustomerServiceInterface } from '../interface/CustomerServiceInterface';

export default class MockCustomerService implements CustomerServiceInterface {
  async getCustomer(): Promise<Customer> {
    return {
      customerID: 'SDG12345678910',
    };
  }
}
